import ContractDetail from './ContractDetail.vue';

export default ContractDetail;
